import { render, staticRenderFns } from "./introduceLayout.vue?vue&type=template&id=6b6d3995&scoped=true"
import script from "./introduceLayout.vue?vue&type=script&lang=js"
export * from "./introduceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d3995",
  null
  
)

export default component.exports